import Hero from '../components/Hero/Hero';
import Stats from '../components/Stats/Stats';
import Problems from '../components/Problems/Problems';
import ClientBenefits from '../components/ClientBenefits/ClientBenefits';
import Solutions from '../components/Solutions/Solutions';
import RealCases from '../components/RealCases/RealCases';
import N8nExample from '../components/N8nExample/N8nExample';
import Workflow from '../components/Workflow/Workflow';
import CostOfNotAutomating from '../components/CostOfNotAutomating/CostOfNotAutomating';
import Differentials from '../components/Differentials/Differentials';
import Technologies from '../components/Technologies/Technologies';
import BlogPreview from '../components/BlogPreview/BlogPreview';
import ContactCTA from '../components/ContactCTA/ContactCTA';

function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <Problems />
      <ClientBenefits />
      <Solutions />
      <RealCases />
      <N8nExample />
      <Workflow />
      <CostOfNotAutomating />
      <Differentials />
      <Technologies />
      <BlogPreview />
      <ContactCTA />
    </>
  );
}

export default Home;
